import { curry, isEmpty } from 'ramda'
import { themr } from 'react-css-themr'
import React from 'react'
// import objProxy from 'identity-obj-proxy'

export default curry((theme, Component) => {
  // eslint-disable-next-line no-process-env
  if (isEmpty(theme) && process.env.NODE_ENV === 'test') {
    // eslint-disable-next-line global-require
    const objProxy = require('identity-obj-proxy')

    // eslint-disable-next-line react/display-name
    return props => <Component {...props} theme={objProxy} />
  }

  return themr('', theme)(Component)
})
